

























import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import Footer from "@/components/Footer.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    Footer,
  },
})
export default class ORegisterPassEditComp extends CheckOrganizationAdminLogin {}
